"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Concur is an SAP Company',
    learn: {
      href: '/sap',
      text: '學到更多'
    }
  },
  social: [{
    network: 'facebook',
    href: ''
  }, {
    network: 'twitter',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }],
  support: {
    links: [{
      text: '聯絡我們',
      href: '/contact'
    }, {
      text: '獲取報價',
      href: '/get-quote'
    }],
    selector: '國家/地區選擇',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: '隱私權政策',
      href: '/privacy-policy'
    }, {
      text: '使用條款',
      href: ''
    }]
  }
};